import {useEffect,useState} from 'react';
import {Analytics} from '@vercel/analytics/react';
import {ANALYTICS_CHOICE_KEY,analyticsAllowed,privacyFilteredEvent} from './analytics-choice';
export default function UsageAnalytics(){
  const onVercel=process.env.REACT_APP_HOSTING_PROVIDER!=='netlify';
  const [started,setStarted]=useState(analyticsAllowed);
  useEffect(()=>{if(!onVercel)return;const sync=event=>{if(event.type!=='storage'||event.key===ANALYTICS_CHOICE_KEY||event.key===null){if(analyticsAllowed())setStarted(true);}};window.addEventListener('storage',sync);window.addEventListener('tradelog-analytics-choice',sync);return()=>{window.removeEventListener('storage',sync);window.removeEventListener('tradelog-analytics-choice',sync);};},[onVercel]);
  // Once loaded, the SDK keeps its beforeSend filter. Withdrawing permission
  // blocks each later event without relying on removing a script element.
  return onVercel&&started?<Analytics beforeSend={privacyFilteredEvent}/>:null;
}
